import gql from "graphql-tag";

export const GET_AVG_POSITION_CHART_DATA = gql`
  query Query($input: getKeywordRankNSearchInput) {
    GetKeywordWithRanks(input: $input)
  }
`;
